import { render, staticRenderFns } from "./ModalCreateContact.vue?vue&type=template&id=340503f8&"
import script from "./ModalCreateContact.vue?vue&type=script&lang=js&"
export * from "./ModalCreateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports